import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {Spinplay} from '../shared/spinplay';
import {DigitalMatch} from '../shared/digital-match';
import {MatchingHistory} from '../shared/matching-history';
import {environment} from '../../environments/environment';

@Injectable()
export class MatchService {

  constructor( private http: HttpClient ) { }
  musicPointUrl = environment.dashboardApiUrl;
  radioFuseUrl = environment.dashboardApiUrl;

  getTopSpinplays(): Observable<Array<Spinplay>> {
    const url = this.musicPointUrl + '/play/unmatched';
    return this.http.get<Array<Spinplay>>(url);
  }

  getSpinplaysByCCID(ccid): Observable<Spinplay> {
    const url = this.musicPointUrl + '/play/ccid/' + ccid;
    return this.http.get<Spinplay>(url);
  }

  getSpinplaysByTitle(title): Observable<Array<Spinplay>> {
    const url = this.musicPointUrl + '/play/title/' + title;
    return this.http.get<Array<Spinplay>>(url);
  }

  getSpinplaysByArtist(artist): Observable<Array<Spinplay>> {
    const url = this.musicPointUrl + '/play/artist/' + artist;
    return this.http.get<Array<Spinplay>>(url);
  }

  getSpinplaysByDays(days): Observable<Array<Spinplay>> {
    const url = this.musicPointUrl + '/play/days/' + days;
    return this.http.get<Array<Spinplay>>(url);
  }

  getElasticResults(artist, title): Observable<Array<DigitalMatch>> {
    const musicPointUrl = this.musicPointUrl + '/play/match/elastic';
    return this.http.post<Array<DigitalMatch>>(musicPointUrl, { 'title' : title, 'artist' : artist});
  }

  getMetadata(ccid: string): Observable<MatchingHistory> {
    const musicPointUrl = this.musicPointUrl + '/play/metadata/' + ccid;
    return this.http.get<MatchingHistory>(musicPointUrl);
  }

  saveOriginalData(match: MatchingHistory): Observable<boolean> {
    const musicPointUrl = this.musicPointUrl + '/play/match';
    return this.http.post<boolean>(musicPointUrl, match);
  }

  saveNoMatch(match: MatchingHistory): Observable<boolean> {
    const musicPointUrl = this.musicPointUrl + '/play/nomatch';
    return this.http.post<boolean>(musicPointUrl, match);
  }

  saveDigitalMatch(match: DigitalMatch, spinPlay: Spinplay): Observable<boolean> {
    const radioFuseUrl = this.radioFuseUrl + '/match';
    return this.http.put<boolean>(radioFuseUrl, this.digitalMatchToMatchingHistory(match, spinPlay));
  }

  digitalMatchToMatchingHistory(match: DigitalMatch, spinPlay: Spinplay) {
    const history: MatchingHistory = {
      ccid: spinPlay.ccid,
      trackTitle: match.title,
      album: match.trackBundleTitle,
      artist: match.artistName,
      version: match.trackVersion,
      genre: match.genre,
      isrc: match.isrc,
      recordLabelName: match.recordLabelName,
      productId: match.id,
      artistId: match.artistId,
      imageUrl: match.imageUrl,
      upc: match.upc,
      dateModified : null,
      collaborativeArtist : match.collaborativeArtist
    };

    return history;
  }
}



// WEBPACK FOOTER //
// ./src/app/match/match.service.ts